import React, { useEffect, useState } from 'react';
import {
    Box, Container, createStyles, Dialog, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select,
    TextField, Theme, IconButton, FormHelperText, DialogActions, Divider, Modal, InputBase, withStyles
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import useCommonApi from '../../api/useCommonApi';
import CloseIcon from '@material-ui/icons/Close';
import LoadingDialog from '../controls/LoadingDialog';
import { useSnackbar } from 'notistack';
import { Autocomplete } from '@material-ui/lab';
import Map from '../map/Map';
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import swal from 'sweetalert2'
import { ISolicitud } from '../../entities/solicitudes/Solicitud';
import { EditLocation, LocationOn } from '@material-ui/icons';
import ReactLoading from 'react-loading';
import ConfirmDireccion from '../controls/ConfirmDireccion';
import Help, { IHelp } from '../help/Help';
import { enums } from "../../enums/enums";
import ConfirmDialog from "../controls/ConfirmDialog";
import { validarRfc } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';

interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    cliente: any
    usuario: any
    esOrigen: boolean,
    esDestino: boolean
    setDistribuidor: (direccion: any) => void,
    ayuda: IHelp
}

export interface IAutocomplete {
    id: number | string
    nombre: string
    nombreColonia: string
    descripcion?: string
    ciudad: any
    pais: any
    estado: any
    codigoPostal?: any
    solicitud: ISolicitud
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '13px'
        },
        direccion: {
            fontSize: '14px',
            fontWeight: 600
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
        padding: {
            padding: "0px"
            
        },
        paddingDialog: {
            padding: "2px 10px"
        },
        paddingDialogContent: {
            padding: "0px"
        },
        iconSearch: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: "#fff",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            fontFamily: "Roboto"
        },
        margin: {
            margin: theme.spacing(1),
          },
    }),
);

const AgregarDireccion = ({ abierto, cerrar, confirmar, cliente, usuario, esOrigen, esDestino, setDistribuidor, ayuda }: Props) => {
    const classes = useStyles();
    const apiSource = useCommonApi();
    const [nombreDistribuidor, setNombreDistribuidor] = useState('');
    const [paises, setPaises] = useState<any[]>([]);
    const [estados, setEstados] = useState<any[]>([]);
    const [ciudades, setCiudades] = useState<any[]>([]);
    const [colonias, setColonias] = useState<any[]>([]);
    const [paisId, setPaisId] = useState(1);
    const [tipoPersonaId, setTipoPersonaId] = useState('');
    const [tiposPersona, setTiposPersona] = useState<any[]>([]);
    const [idFiscal, setIdFiscal] = useState('');
    const [rfc, setRFC] = useState('');
    const [residenciaFiscalId, setResidenciaFiscalId] = useState('');
    const [estadoId, setEstadoId] = useState('');
    const [ciudadId, setCiudadId] = useState('');
    const [coloniaId, setColoniaId] = useState(0);
    const [coloniaSeleccionada, setColoniaSeleccionada] = useState<string[]>([]);
    const [calle, setCalle] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [noExterior, setNoExterior] = useState('');
    const [noInterior, setNoInterior] = useState('');
    const [telefono, setTelefono] = useState('');
    const [noBodega, setNoBodega] = useState('');
    const [noDistribuidor, setNumeroDistribuidor] = useState(0);
    const [formularioValido, setFormularioValido] = useState(true);
    const [showLoading, setLoading] = useState(false);
    const [distribuidores, setDistribuidores] = useState<any[]>([]);
    const [ubicacionOriginal, setUbicacionOriginal] = useState({ latitud: 0, longitud: 0 });
    const [ubicacionVerificada, setUbicacionVerificada] = useState({ latitud: 0, longitud: 0 });
    const { enqueueSnackbar } = useSnackbar();
    const [direccion, setDireccion] = useState('');
    const [googleApi, setGoogleAPI] = useState('');
    const [googleMapApi, setGoogleMapAPI] = useState('');
    const [buscandoCoordenadas, setBuscandoCoordenadas] = useState(false);
    const [zoom, setZoom] = useState(6);
    const [currentZoom, setCurrentZoom] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);
    const [showAlertGeopunto, setShowAlertGeopunto] = useState(false);
    const [modalStyle] = useState(getModalStyle);
    const [buscoGeopunto, setBuscoGeopunto] = useState(false);
    const [showBuscoGeopunto, setShowBuscoGeopunto] = useState(false);
    const [residenciasFiscales, setResidenciasFiscales] = useState<any[]>([]);
    
    const [habilitaGuardar, setHabilitaGuardar] = useState(false);
    const [guardaUbicacion, setGuardaUbicacion] = useState(false);
    const [habilitaBuscarUbicacion, setHabilitaBuscarUbicacion] = useState(false);
    const [rfcValido, setRFCValido] = useState(true);
    const [mostrarConfirm, setMostrarConfirm] = useState<boolean>(false);
    const [hayModificacion, setHayModificacion] = useState<boolean>(false);
    const tipoPersona = enums.tipoPersonaRazonSocial;

    const [isDisabledNRF, setIsDisabledNRF] = useState<boolean>(false);

    function getModalStyle() {
        const top = 50;
        const left = 50;

        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }

    const coordenadas = [{ id: 1, latitud: 23.634501, longitud: -102.552784 },
    { id: 2, latitud: 37.09024, longitud: -95.712891 },
    { id: 3, latitud: 56.130366, longitud: -106.346771 },
    { id: 4, latitud: 37.09024, longitud: -95.712891 }];

    const handleChangePais = (event: React.ChangeEvent<{ value: unknown }>) => {
        setPaisId(Number(event.target.value));
        setEstadoId('');
        setCiudadId('');
        setColoniaId(0);
        setColoniaSeleccionada([]);
        setCalle('');
        setNoExterior('');
        setNoInterior('');
        setHayModificacion(true);
        getCatalogos("/estado/estado-pais/" + event.target.value).then(data => {
            setEstados(data);
        });

        if (Number(event.target.value) > 0) {
            handleBuscaDireccion(Number(event.target.value));
        }
        else {
            setEstados([]);
            setCiudades([]);
            setColonias([]);
        }
    };

    const handleChangeEstado = (event: React.ChangeEvent<{ value: unknown }>) => {

        setEstadoId(String(event.target.value));
        setColoniaSeleccionada([]);
        setCiudadId('');
        setColoniaId(0);
        getCatalogos("/ciudad/ciudad-estado/" + event.target.value).then(data => {
            setCiudades(data);
        });
        setHayModificacion(true);
    };

    const handleChangeCiudad = (event: React.ChangeEvent<{ value: unknown }>) => {
        setCiudadId(String(event.target.value));
        setColoniaSeleccionada([]);
        setColoniaId(0);
        getCatalogos("/colonia/colonia-ciudad/" + event.target.value).then(data => {
            setColonias(data);
        });
    };

    const handleChangeColonia = (event: any) => {
        if (event !== null) {
            setCodigoPostal(event.codigoPostal);
            setColoniaId(Number(event.id));
            setColoniaSeleccionada(event);
            setCalle('');
            setNoExterior('');
            //changeBuscaDireccion();
        }
    };

    const handleChangeCodigoPostal = (event) => {
        setEstadoId('');
        setCiudadId('');
        setColoniaId(0);
        setColoniaSeleccionada([]);
        setCalle('');
        setNoExterior('');
        setNoInterior('');
        setUbicacionVerificada({ latitud: 0, longitud: 0 });
        let cp = event.target.value.replace(/[^0-9]/gi, "");
        setCodigoPostal(cp);

        if (!!cp)
            setHayModificacion(true);
    };

    const handleNoExterior = (event: any) => {
        let noExt = event.target.value.replace(/[^0-9]/gi, "");
        setNoExterior(noExt);

        if (!!noExt)
            setHayModificacion(true);
    };

    const handleNoInterior = (event: any) => {
        let noInt = event.target.value;//.replace(/[^0-9]/gi, "");
        setNoInterior(noInt);

        if (!!noInt)
            setHayModificacion(true);
    };

    const handleTelefono = (event: any) => {
        let tel = event.target.value.replace(/[^0-9]/gi, "");
        setTelefono(tel);

        if(!!tel)
            setHayModificacion(true);
    };

    const handleNoBodega = (event: any) => {
        let bodega = event.target.value.replace(/[^0-9]/gi, "");
        setNoBodega(bodega);

        if(!!bodega)
            setHayModificacion(true);
    };

    const handleCalle = (event: any) => {
        let calle = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
        setCalle(calle);
        setHayModificacion(true);
    };

    const handlePaisNombre = (paisId) => {
        let countryCode = '';
        let nombrePais = paises.filter(p => p.id === paisId);

        if (nombrePais.length) {
            switch (nombrePais[0]['nombre']) {
                case "MEXICO":
                    countryCode = 'MX';
                    break;
                case "EU":
                    countryCode = 'US';
                    break;
                case "CANADA":
                    countryCode = 'CA';
                    break;
                case "ALASKA":
                    countryCode = 'US';
                    break;
            }
        }
        return countryCode;
    }
    const handleEstadoNombre = (estadoId) => {
        let nombreEstado = estados.filter(p => p.id === Number(estadoId));
        return nombreEstado.length ? nombreEstado[0]['nombre'] : '';
    }
    const handleCiudadNombre = (ciudadId) => {
        let nombreCiudad = ciudades.filter(p => p.id === Number(ciudadId));
        return nombreCiudad.length ? nombreCiudad[0]['nombre'] : '';
    }
    const handleColoniaNombre = (coloniaId) => {
        let nombreColonia = colonias.filter(p => p.id === coloniaId);
        return nombreColonia.length ? nombreColonia[0]['nombreColonia'] : '';
    }

    const handleCloseModal = () => {
        setShowAlert(false);
        setShowAlertError(false);
    }

    const alertText = (
        <Dialog open={abierto} maxWidth={"sm"} onClose={handleCloseModal} >
            <DialogTitle id="simple-dialog-title">
                <span style={{ paddingRight: "65%", paddingLeft: "20px", fontSize: "30px" }}>
                    {/* ¡Alerta! */
                        traducirMessage(273)}
                </span>
                <IconButton aria-label="close" onClick={handleCloseModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{ fontSize: "18px", textAlign: "justify" }}>
                    <div style={{ display: "flex" }}>
                        <EditLocation style={{ color: "#00653b", width: "65px", height: "60px" }} />
                        <div style={{ width: "80%" }}>
                            {/* Si el geo punto referenciado en el mapa no corresponde a la ubicación deseada, puede arrastrar el punto hacia al lugar exacto donde se desea. */
                                traducirMessage(263)}
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>

        </Dialog>
    );

    const alertTextError = (
        <Dialog open={abierto} maxWidth={"sm"} onClose={handleCloseModal} >
            <DialogTitle id="simple-dialog-title">
                <span style={{ paddingRight: "65%", paddingLeft: "20px", fontSize: "30px" }}>
                    {/* ¡Alerta! */
                        traducirMessage(273)}
                </span>
                <IconButton aria-label="close" onClick={handleCloseModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{ fontSize: "18px", textAlign: "justify" }}>
                    <div style={{ display: "flex" }}>
                        <EditLocation style={{ color: "#00653b", width: "65px", height: "60px" }} />
                        <div style={{ width: "80%" }}>
                            {/* No se encontró el punto en el mapa de la dirección registrada, favor de arrastrar el punto en la dirección correcta. */
                                traducirMessage(294)}
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>

        </Dialog>
    );

    const getGeolocalizacion = (busco) => {
        if (busco.target !== undefined) {
            setBuscoGeopunto(true);
        }
        setGuardaUbicacion(true);
        //setBuscandoCoordenadas(true);
        setUbicacionVerificada({ latitud: 0, longitud: 0 });
        let codigoPais = handlePaisNombre(paisId);
        let estadoNombre = handleEstadoNombre(estadoId);
        let ciudadNombre = handleCiudadNombre(ciudadId);
        let coloniaNombre = handleColoniaNombre(coloniaId);

        buscarCoordenadasPorDireccion(codigoPais, estadoNombre, ciudadNombre, coloniaNombre).then(resAddress => {
            if (resAddress !== null &&  (resAddress['results'] === undefined ? false : resAddress['results'].length)) {
                setBuscandoCoordenadas(true);
                if (resAddress['results'][0]['geometry'] !== undefined) {
                    setUbicacionOriginal({ latitud: resAddress['results'][0]['geometry']['location']['lat'], longitud: resAddress['results'][0]['geometry']['location']['lng'] });
                    if(currentZoom === 0){
                        setZoom(15);
                    }
                    if (coloniaNombre !== '') {
                        if(currentZoom === 0){
                            setZoom(17);
                        }
                    }
                    if (calle !== '') {
                        if(currentZoom === 0){
                            setZoom(20);
                        }
                        setShowAlert(true);
                    }
                    setBuscandoCoordenadas(false);
                }
            }
            else if(resAddress['status']==='REQUEST_DENIED'){
                let findCoordenada = coordenadas.filter(p => p.id === paisId);
                if(ubicacionOriginal.latitud !== 0 && ubicacionOriginal.longitud !== 0 ){
                    setUbicacionOriginal({ latitud: ubicacionOriginal.latitud, longitud: ubicacionOriginal.longitud });
                }
                else if (findCoordenada.length) {
                    setUbicacionOriginal({ latitud: findCoordenada[0].latitud, longitud: findCoordenada[0].longitud });
                }
                setBuscandoCoordenadas(false);
            }
            else {
                let findCoordenada = coordenadas.filter(p => p.id === paisId);
                setShowAlertError(true);
                if(ubicacionOriginal.latitud !== 0 && ubicacionOriginal.longitud !== 0 ){
                    setUbicacionOriginal({ latitud: ubicacionOriginal.latitud, longitud: ubicacionOriginal.longitud });
                }
                else if (findCoordenada.length) {
                    setUbicacionOriginal({ latitud: findCoordenada[0].latitud, longitud: findCoordenada[0].longitud });
                }

                setBuscandoCoordenadas(false);
            }
        });
    }

    const changeBuscaDireccion = () => {
        handleBuscaDireccion(paisId);
    }

    const handleBuscaDireccion = (paisId) => {
        if (paisId === 0 && codigoPostal !== undefined) {
            let paisesCP = '';
            getPaisesCodigoPostal(codigoPostal).then(res => {
                if (res.length && res.length > 1) {
                    res.forEach((value, index) => {
                        paisesCP += res.length - 1 !== index ? paises.filter(t => t.id === value.paisID)[0].nombre + "," : paises.filter(t => t.id === value.paisID)[0].nombre;
                        if (res.length - 1 !== index) {

                        }
                    });
                    let mensaje = traducirMessage(51); //`El código postal se encuentra en dos paises diferentes ${paisesCP}. Favor de seleccionar el país de acuerdo a su código postal capturado.`;
                    enqueueSnackbar(mensaje, { variant: "warning" });
                    return;
                }
            });
        }

        if (paisId > 0 && codigoPostal !== undefined) {
            buscarPorCodigoPostal(paisId).then(response => {
                if (response !== null && response.length) {
                    setEstadoId(response[0].estado.id);

                    getCatalogos("/ciudad/ciudad-estado/" + response[0].estado.id).then(data => {
                        setCiudades(data);
                        setCiudadId(response[0].ciudad.id);
                        let colonias: any[] = [];
                        response.forEach(col => {

                            colonias.push({ id: col.id, nombreColonia: col.nombreColonia, codigoPostal: col.codigoPostal });
                        });
                        setColonias(colonias);
                        setColoniaId(0);
                        setColoniaSeleccionada([]);
                        getGeolocalizacion(false);
                    });
                }
                else {
                    setBuscandoCoordenadas(true);
                    setEstadoId('');
                    setCiudadId('');
                    setColoniaId(0);
                    setColoniaSeleccionada([]);
                    let findCoordenada = coordenadas.filter(p => p.id === paisId);
                    if (findCoordenada.length) {
                        setUbicacionOriginal({ latitud: findCoordenada[0].latitud, longitud: findCoordenada[0].longitud });
                        setZoom(6);
                        setTimeout(() => {
                            setBuscandoCoordenadas(false);
                        }, 1000);
                    }
                }
            });
        }
    }

    const setClienteDistribuidorComplemento = (clienteDistribuidorID): any => {
        return {
            clienteDistribuidorComplementoID: 0,
            clienteID: cliente.id,
            clienteDistribuidorID: clienteDistribuidorID,
            rfc: rfc,
            tipoPersonaID: tipoPersonaId,
            numeroIdentificaciónFiscal: idFiscal,
            residenciaFiscal: residenciaFiscalId
        }
    }

    const setDireccionDto = (): any => {
        return {
            clienteID: cliente.id,
            noDistribuidor: noDistribuidor.toString(),
            nombreClienteDistribuidor: nombreDistribuidor,
            codigoPostal: codigoPostal,
            paisId: paisId,
            estadoId: estadoId,
            ciudadId: ciudadId,
            coloniaId: coloniaId,
            calle: calle.toUpperCase(),
            noExterior: noExterior,
            noInterior: noInterior,
            esRemitente: esOrigen,
            esDestinatario: esDestino,
            auditFecha: new Date(),
            auditUsuarioID: usuario.id,
            nombrePCMod: usuario.nombre,
            cedis: '',
            direccion: direccion,
            esActivo: 1,
            esNotificarRemitente: 0,
            esNotificarDestinatario: 0,
            rfc: rfc,
            tipoPersonaId: tipoPersonaId,
            telefono: telefono,
            noBodega: noBodega??""
        }
    };

    const setDireccionUbicacionDto = (clienteDistribuidor, validada): any => {
        return {
            clienteID: cliente.id,
            clienteDistribuidorID: clienteDistribuidor.clienteDistribuidorID,
            direccion: setDireccionUbicacion(),
            codigoPostal: codigoPostal,
            latitudOriginal: ubicacionOriginal.latitud,
            longitudOriginal: ubicacionOriginal.longitud,
            latitudVerificada: validada ? (ubicacionVerificada.latitud !== 0 ? ubicacionVerificada.latitud : ubicacionOriginal.latitud) : ubicacionOriginal.latitud,
            longitudVerificada: validada ? (ubicacionVerificada.longitud !== 0 ? ubicacionVerificada.longitud : ubicacionOriginal.longitud) : ubicacionOriginal.longitud,
            l_verificado: validada
        }
    };

    const setDireccionUbicacion = () => {
        let paisNombre = paises.filter(t => t.id === paisId).length ? paises.filter(t => t.id === paisId)[0].nombre : ' ';
        let estadoNombre = estados.filter(t => t.id === Number(estadoId)).length ? estados.filter(t => t.id === Number(estadoId))[0].nombre : ' ';
        let ciudadNombre = ciudades.filter(t => t.id === Number(ciudadId)).length ? ciudades.filter(t => t.id === Number(ciudadId))[0].nombre : ' ';
        let direccion = paisNombre + ' ' + estadoNombre + ' ' + ciudadNombre + ' ' + calle + ' ' + noExterior + ' ' + noInterior;

        return direccion.toUpperCase();
    }

    const guardaDireccion = async () => {
        const result = await apiSource.postAsync<any>("cliente-distribuidor", setDireccionDto());
        return result;
    };

    const guardaClienteDistribuidorComplemento = async (clienteDistribuidorId) => {
        const result = await apiSource.postAsync<any>("cliente-distribuidor-complemento", setClienteDistribuidorComplemento(clienteDistribuidorId));
        return result;
    };

    const buscarPorCodigoPostal = async (paisId?: number) => {
        const data = { Texto: codigoPostal, paisId: paisId };
        const result = await apiSource.obtenerAsync<IAutocomplete[]>("colonia/by-text-and-country", data);
        return result;
    }

    const getCatalogos = async (url) => {
        const result = await apiSource.obtenerAsync<any>(url);
        return result;
    };

    const getPaisesCodigoPostal = async (codigoPostal) => {
        const result = await apiSource.obtenerAsync<any>("colonia/codigo-postal-paises?codigoPostal=" + codigoPostal);
        return result;
    };

    const handleChangeTipoPersona = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = Number(event.target.value);

        setRFC('');

        if (value === tipoPersona.particular || value === tipoPersona.extranjero) {
            setRFC(value === tipoPersona.particular ? enums.tipoRfc.particular : enums.tipoRfc.extranjero);
            setRFCValido(true);
        }
        if(value===tipoPersona.extranjero){
            setIsDisabledNRF(false);
            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : '0'
            );
        }
        if(value!==tipoPersona.extranjero){
            setIsDisabledNRF(true);
            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : ''
            );
            
            setIdFiscal(                
                typeof event.target.value === 'string'
                ? event.target.value : ''
            );
        }

        if (value === tipoPersona.fisica || value === tipoPersona.gubernamental || value === tipoPersona.moral || value === tipoPersona.particular) {
            setIsDisabledNRF(true);
        }

        setTipoPersonaId(String(value));
        setHayModificacion(true);
    };

    const handleChangeResidenciaFiscal = (event: React.ChangeEvent<{ value: unknown }>) => {
        setResidenciaFiscalId(
            typeof event.target.value === 'string'
                ? event.target.value : ''
        );
        setHayModificacion(true);
    };

    const buscarCoordenadasPorDireccion = async (countryCode, estado, ciudad, colonia) => {
        const data = {
            subscriptionKey: googleApi,
            cp: codigoPostal,
            pais: countryCode,
            estado: estado,
            ciudad: ciudad,
            colonia: colonia,
            calle: calle,
            calleNo: noExterior,
            username: localStorage.getItem("usuario_nombre")
        };
        const result = await apiSource.obtenerAsync<IAutocomplete[]>("solicitud-servicio/get-geocode-by-address", data);
        return result;
    }

    const validarDireccion = () => {
        setFormularioValido(false);

        if (cliente.habilitarDatosComplementarios) {
            if (tipoPersonaId === "" || !rfc) {
                return;
            }
        }
        if (!rfcValido || (tipoPersonaId === "5" && (residenciaFiscalId === '' || idFiscal === '' || residenciaFiscalId === '0'))) {
            return;
        }

        if(tipoPersonaId==="5" && residenciaFiscalId === 'MEX'){
            let message=traducirMessage(292); //"Para clientes extranjeros la clave de país contenida deberá ser distinta a México";
            enqueueSnackbar(message, { variant: "error" });
            return;
        }

        if(tipoPersonaId==="5" && (residenciaFiscalId === 'USA' || residenciaFiscalId === 'CAN')){
            let regex = /^[0-9]*$/;
            let isValid = regex.test(idFiscal);
            if (idFiscal.length !== 9 || !isValid) {
                let message=traducirMessage(293); //"El Número de Identificación Fiscal es incorrecto."; 
                enqueueSnackbar(message, { variant: "error" });
                return;
            }
        }

        if(tipoPersonaId==="5" && (residenciaFiscalId !== 'USA' && residenciaFiscalId !== 'CAN')){
            let regex = /^[a-z0-9A-Z]*$/;
            let isValid = regex.test(idFiscal);
            if (idFiscal.length < 6 || idFiscal.length > 40 || !isValid) {
                let message=traducirMessage(293); //"El Número de Identificación Fiscal es incorrecto."; 
                enqueueSnackbar(message, { variant: "error" });
                return;
            }
        }

        if (paisId !== 0 && estadoId !== "" && ciudadId !== "" && coloniaId !== 0 && calle !== '' && codigoPostal !== null && noExterior !== '' && nombreDistribuidor !== '' && telefono !=='') {
            if (!calle.match(/[<>]/) && !nombreDistribuidor.match(/[<>]/) && !noInterior.match(/[<>]/)) {
                setFormularioValido(true);
                setShowAlertGeopunto(true);
            }

        }
    };

    const guardaInfoDireccion = (validada) => {
        setLoading(true);
        guardaDireccion().then(response => {
            if (response.clienteID === 0) {
                enqueueSnackbar("RFC Inválido", { variant: "error" });
                setLoading(false);
                return;
            }

            guardaClienteUbicacion(response, validada).then(ubicacion => {
                guardaClienteDistribuidorComplemento(response.clienteDistribuidorID).then(complemento => {
                    setLoading(false);

                    if (setDistribuidor) {
                        setDistribuidor({
                            ...response,
                            id: response.clienteDistribuidorID,
                            nombreColonia: response.colonium.nombreColonia,
                            clienteDistribuidorComplementos: {
                                clienteDistribuidorComplementoID: complemento.clienteDistribuidorComplementoID,
                                clienteDistribuidorID: response.clienteDistribuidorID,
                                clienteID: cliente.id,
                                numeroIdentificaciónFiscal: idFiscal,
                                residenciaFiscal: residenciaFiscalId,
                                rfc: rfc,
                                tipoPersonaID: tipoPersonaId,
                            },

                        });
                    }

                    confirmar();
                    swal.fire({
                        titleText: traducirMessage(14), // '¡Exitoso!',
                        text: traducirMessage(143), // "La dirección se ha guardado exitosamente.",
                        type: 'success',

                    });
                })
            });
        }).catch(err => {
            setLoading(false);
            confirmar();
            swal.fire({
                titleText: traducirMessage(272), // 'Error!',
                text: traducirMessage(210), // "Ocurrio un error al guardar la dirección.",
                type: 'error',
            });

        });
    }

    const getResidenciasFiscales = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-catalogo-residencia-fiscal",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    useEffect(() => {
        getCatalogos("/pais/many").then(data => {
            setPaises(data);
            setPaisId(1);
            getCatalogos("/estado/estado-pais/" + 1).then(data => {
                setEstados(data);
            });

            getResidenciasFiscales().then(data => {
                setResidenciasFiscales(data);
            });
        });

        getCatalogos("/tipo-persona/many").then(data => {
            setTiposPersona(data);
        });
        getDistribuidorCliente().then(result => {
            setDistribuidores(result);
        });

        let findCoordenada = coordenadas.filter(p => p.id === 1);
        if (findCoordenada.length) {
            setUbicacionOriginal({ latitud: findCoordenada[0].latitud, longitud: findCoordenada[0].longitud });
        }

        setGoogleAPI(process.env.REACT_APP_GOOGLE_GEOCODE_KEY || '');
    }, []);

    const setEstadoMapa = (estado, ciudad, colonia) => {
        getCatalogos("/estado/estado-pais/" + paisId).then(estados => {
            setEstados(estados);
            let estadoId = estados.filter(t => t.nombre === estado.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
            if (estadoId.length > 0) {
                setEstadoId(estadoId[0].id);
                getCatalogos("/ciudad/ciudad-estado/" + estadoId[0].id).then(ciudades => {
                    setCiudades(ciudades);
                    let ciudadId = ciudades.filter(t => t.nombre === ciudad.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                    if (ciudadId.length > 0) {
                        setCiudadId(ciudadId[0].id);
                        getCatalogos("/colonia/colonia-ciudad/" + ciudadId[0].id).then(colonias => {
                            setColonias(colonias);
                            let coloniaId = colonias.filter(t => t.nombre === colonia.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                            if (coloniaId.length > 0) {
                                setColoniaId(coloniaId[0].id);
                            }
                        });
                    }
                });
            }
        });
    }

    const cerrarConfirmarDireccion = () => {
        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
        setLoading(true);
        guardaInfoDireccion(true);
    };

    const cerrarGuardarDireccion = () => {

        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
        setLoading(true);
        guardaInfoDireccion(false);
    };

    const cerrarCancelarDireccion = () => {
        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
    };

    const setUbicacionMapa = (ubicacion) => {
        setUbicacionVerificada({ latitud: ubicacion.latitud, longitud: ubicacion.longitud });
    }

    const getDistribuidorCliente = async () => {
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor/by-filtro/" + cliente.id);
        return result;
    };

    const guardaClienteUbicacion = async (clienteDistribuidor, validada) => {
        const result = await apiSource.postAsync<any>("cliente-distribuidor-direccion", setDireccionUbicacionDto(clienteDistribuidor, validada));
        return result;
    };

    const handleNombreDistribuidor = (data: any) => {
        let value = data;
        value = value.replace(/[^a-zA-Z ]/g, "");
        setNombreDistribuidor(value);
        setHayModificacion(true);
    }

    const validateRFC = (e) => {
        const rfcValido = validarRfc(e.target.value, Number(tipoPersonaId));
        setRFCValido(rfcValido);
    }

    const mostrarConfirmarCerrar = () => {
        if (hayModificacion)
            setMostrarConfirm(true);
        else
            cerrar();
    }

    const handleZoomChanged = (currentZoom) => {
        setZoom(currentZoom);
        setCurrentZoom(currentZoom);
    }

    useEffect(() => {
        if(nombreDistribuidor!=="" && tipoPersonaId !=="" 
            && (Number(tipoPersonaId) === tipoPersona.extranjero ? (idFiscal !== "" && residenciaFiscalId !== "" && residenciaFiscalId !== "0") : (rfcValido && rfc !== ""))
            && paisId !== 0
            && codigoPostal !== ""
            && estadoId !== ""
            && ciudadId !== ""
            && coloniaId !== 0
            && calle !== ""
            && noExterior !== ""
            && telefono !== ""
            && guardaUbicacion
            
        ){
            setHabilitaGuardar(true);
        }
        else{
            setHabilitaGuardar(false);
        }
        
      }, [nombreDistribuidor,tipoPersonaId,rfcValido,idFiscal,residenciaFiscalId,paisId,codigoPostal,estadoId,ciudadId,coloniaId,calle,noExterior,telefono,guardaUbicacion]);

      useEffect(() => {
        if( paisId !== 0
            && codigoPostal !== ""
            && estadoId !== ""
            && ciudadId !== ""
            && coloniaId !== 0
            && calle !== ""
            && noExterior !== ""
            
        ){
            setHabilitaBuscarUbicacion(true);
        }
        else{
            setHabilitaBuscarUbicacion(false);
        }
        
      }, [paisId,codigoPostal,estadoId,ciudadId,coloniaId, calle,noExterior]);

    //   useEffect(() => { 
    //     setColoniaId(0);
    //   }, [codigoPostal, estadoId, ciudadId])

      useEffect(() => { 
        if( paisId !== 0
            && codigoPostal !== ""
            && estadoId !== ""
            && ciudadId !== ""
            && coloniaId !== 0
        ){
            setEstadoId(estadoId);
            setCiudadId(ciudadId);
            setUbicacionVerificada({ latitud: 0, longitud: 0 });
            getGeolocalizacion(true);
        }       
      }, [codigoPostal, estadoId, ciudadId, coloniaId])


    return (<>
        <Dialog open={abierto} fullScreen  onClose={mostrarConfirmarCerrar}>
            <DialogTitle className={classes.paddingDialog}>
                <Box display="flex" alignItems="center">
                    <Box>
                        <Help comments={traducirMessage(32)} customStyle={{ top: "-25px", right: "-35px" }} />
                    </Box>
                    <Box flexGrow={1} textAlign="center">
                        {/* Nueva Dirección */
                            traducirLabel(211)}
                    </Box>
                    <Box>
                        <IconButton onClick={mostrarConfirmarCerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent className={classes.paddingDialogContent}>
                <DialogContentText>
                    <Container maxWidth="xl"  >
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                                <Box flexGrow={1} className={classes.direccion} component={'span'} style={nombreDistribuidor === '' && !formularioValido ? { color: "red" } : {}}>
                                    {/* NOMBRE DISTRIBUIDOR */
                                        traducirLabel(205)}
                                </Box>

                                <TextField className={classes.padding} fullWidth id="nombreDistribuidor"
                                    value={nombreDistribuidor}
                                    error={nombreDistribuidor === '' && !formularioValido}
                                    helperText={nombreDistribuidor === '' && !formularioValido ? 'Campo requerido' : ''}
                                    onChange={e => handleNombreDistribuidor(e.target.value)}
                                    size="small"
                                    variant="outlined"
                                />
                            </Grid>

                            <Grid item xs={3}>
                                
                                <TextField className={classes.padding} fullWidth id="tipoPersona" variant="outlined"  required
                                    size="small"
                                    label={traducirLabel(301)} /*"Tipo Persona"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={tipoPersonaId}
                                    error={(tipoPersonaId === null || tipoPersonaId === undefined || tipoPersonaId === "0") && !formularioValido}
                                    helperText={(tipoPersonaId === null || tipoPersonaId === undefined || tipoPersonaId === "0") && !formularioValido ? traducirLabel(25) /*'Campo requerido'*/ : ''}
                                    onChange={handleChangeTipoPersona}
                                    select
                                >
                                    <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */}
                                            {traducirMessage(241)}
                                        </MenuItem>
                                        {tiposPersona !== null && localStorage.getItem("idioma") === 'en-US' && tiposPersona.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.etiquetaTipoPersona.nombre}
                                            </MenuItem>
                                        ))}
                                        {tiposPersona !== null && localStorage.getItem("idioma") !== 'en-US' && tiposPersona.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))}
                                </TextField>

                                <FormHelperText error>
                                    {tipoPersonaId === "0" && cliente.habilitarDatosComplementarios && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="rfc" variant="outlined" label={traducirLabel(268)} /*"RFC"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    required={cliente.habilitarDatosComplementarios}
                                    title={cliente.habilitarDatosComplementarios === true ? traducirMessage(298) : ''}
                                    value={rfc}
                                    disabled={!tipoPersonaId || Number(tipoPersonaId) === tipoPersona.particular || Number(tipoPersonaId) === tipoPersona.extranjero}
                                    onKeyUp={validateRFC}
                                    onChange={e => setRFC(e.target.value)}
                                    error={rfc === "" && cliente.habilitarDatosComplementarios && !formularioValido}
                                    helperText={rfc === "" && cliente.habilitarDatosComplementarios && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                    inputProps={{ maxLength: Number(tipoPersonaId) === tipoPersona.moral ? 12 : 13 }}
				                    size="small"
                                />
                                <FormHelperText
                                    error>{!rfcValido && cliente.habilitarDatosComplementarios && !formularioValido ? traducirLabel(269) : '' /* RFC no válido */}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="rfc" variant="outlined"
                                    label={traducirLabel(215)} /*"Número Identificación Fiscal"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={idFiscal}
                                    onChange={e => {
                                        setIdFiscal(e.target.value);
                                        setHayModificacion(true);
                                    }}
                                    required={tipoPersonaId === "5"}
                                    title={tipoPersonaId === "5" ? traducirMessage(298) : ''}
                                    error={(idFiscal === "" || idFiscal === null || idFiscal === undefined) && tipoPersonaId === "5" && !formularioValido}
                                    helperText={idFiscal === "" && tipoPersonaId === "5" && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                    inputProps={{ maxLength: 256 }} 
				                    size="small"
                                    disabled={isDisabledNRF}/>
                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="residenciaFiscal" variant="outlined"  required={tipoPersonaId === "5"} error={tipoPersonaId === "5" && !residenciaFiscalId && !formularioValido ? true : false}
                                    size="small"
                                    label={ traducirLabel(263)}//"Residencia Fiscal"
                                    
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={residenciaFiscalId}
                                    onChange={handleChangeResidenciaFiscal}
                                    select
                                    disabled={isDisabledNRF}
                                >
                                    <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirMessage(241)}
                                        </MenuItem>
                                        {residenciasFiscales !== null && residenciasFiscales.map((option) => (
                                            <MenuItem key={option.clave} value={option.clave}>
                                                {option.descripcion}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12}>
                                <Box flexGrow={1} className={classes.direccion}>
                                    {/* DIRECCIÓN(CALLE, NO EXT, NO INT,COLONIA) */
                                        traducirLabel(96)}
                                </Box>
                            </Grid>

                            <Grid item xs={2}>
                                <TextField className={classes.padding} fullWidth id="pais" variant="outlined"  error={paisId === 0 && !formularioValido ? true : false}
                                    size="small"
                                    label={traducirLabel(224)} /*"País"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={paisId}
                                    onChange={handleChangePais}
                                    select
                                >
                                    <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirMessage(241)}
                                        </MenuItem>
                                        {localStorage.getItem("idioma") === 'en-US' && paises !== null && paises.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.etiquetaPais.nombre}
                                            </MenuItem>
                                        ))}
                                        {localStorage.getItem("idioma") !== 'en-US' && paises !== null && paises.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                                <FormHelperText error >
                                    {paisId === 0 && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={1}>
                                <TextField className={classes.padding} fullWidth id="cp" variant="outlined" label={traducirLabel(61)} /*"CP"*/ required
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={codigoPostal}
                                    error={codigoPostal === "" && !formularioValido}
                                    helperText={codigoPostal === "" && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                    onChange={handleChangeCodigoPostal}
                                    onBlur={changeBuscaDireccion}
                                    size="small"
                                    title={traducirMessage(298)}
                                    inputProps={{ maxLength: 10 }} />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="estado" variant="outlined"  error={estadoId === "" && !formularioValido ? true : false}
                                    size="small"
                                    label={traducirLabel(123)} /*"Estado"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={estadoId}
                                    onChange={handleChangeEstado}
                                    select
                                >
                                    <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirMessage(241)}
                                        </MenuItem>

                                        {estados !== null && estados.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))}
                                        
                                </TextField>
                                <FormHelperText error >
                                    {estadoId === "" && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="ciudad" variant="outlined"  error={ciudadId === "" && !formularioValido ? true : false}
                                    size="small"
                                    label={traducirLabel(33)} /*"Ciudad"*/
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={ciudadId}
                                    onChange={handleChangeCiudad}
                                    select
                                >
                                    <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirMessage(241)}
                                        </MenuItem>
                                        {ciudades !== null && ciudades.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                                <FormHelperText error >{ciudadId === "" && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}</FormHelperText>
                            </Grid>

                            <Grid item xs={3}>
                                <FormControl required fullWidth variant="outlined" >
                                    <Autocomplete
                                        options={colonias}
                                        getOptionLabel={(option) => option.nombreColonia}
                                        value={coloniaSeleccionada}
                                        size="small"
                                        onChange={(event, value) => handleChangeColonia(value)}
                                        renderInput={(params) => (
                                            <TextField className={classes.padding} label={traducirLabel(42)/* Colonia */}   {...params} InputLabelProps={{
                                                classes: {
                                                  root: classes.label
                                                }
                                              }}
                                              variant="outlined" />
                                        )}
                                    />
                                </FormControl>
                                <FormHelperText error>
                                    {coloniaId === 0 && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                </FormHelperText>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="calle" variant="outlined" label={traducirLabel(24)} /*"Calle"*/ required
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={calle}
                                    title={traducirMessage(298)}
                                    size="small"
                                    error={(calle === "" && !formularioValido) ? true : (calle !== "" && calle.match(/[<>]/) ? true : false)}
                                    helperText={(calle === "" && !formularioValido) ? traducirLabel(25) /* Campo requerido */ : (calle !== "" && calle.match(/[<>]/)) ? traducirMessage(203) : '' /* No se permiten los caracteres especiales <> en este campo */}
                                    onChange={handleCalle} inputProps={{ maxLength: 50 }} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField className={classes.padding} fullWidth id="noExterior" variant="outlined" label={traducirLabel(196)/* No. Exterior */} required
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    value={noExterior}
                                    size="small"
                                    title={traducirMessage(298)}
                                    error={noExterior === "" && !formularioValido}
                                    helperText={noExterior === "" && !formularioValido ? traducirLabel(25) : '' /* Campo requerido */}
                                    onChange={handleNoExterior} inputProps={{ maxLength: 10 }} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField className={classes.padding} fullWidth id="noInterior" variant="outlined" label={traducirLabel(198)/* No. Interior */}
                                    InputLabelProps={{
                                        classes: {
                                          root: classes.label
                                        }
                                      }}
                                    size="small"
                                    value={noInterior}
                                    inputProps={{ maxLength: 10 }} onChange={handleNoInterior} />

                            </Grid>

                            <Grid item xs={2}>
                                <TextField className={classes.padding} fullWidth id="telefono" variant="outlined" label={traducirLabel(290)} /*"Teléfono"*/ required
                                           InputLabelProps={{
                                            classes: {
                                              root: classes.label
                                            }
                                           }}
                                           value={telefono}
                                           size="small"
                                           title={traducirMessage(298)}
                                           error={telefono === "" && !formularioValido}
                                           helperText={telefono === "" && !formularioValido ? traducirLabel(25) : ''}
                                           inputProps={{ maxLength: 25 }} onChange={handleTelefono} />

                            </Grid>

                            <Grid item xs={3}>
                                <TextField className={classes.padding} fullWidth id="noBodega" variant="outlined" label={traducirLabel(194)} /*"No. Bodega"*/
                                           InputLabelProps={{
                                            classes: {
                                              root: classes.label
                                            }
                                           }}
                                           value={noBodega}
                                           size="small"
                                           inputProps={{ maxLength: 6 }} onChange={handleNoBodega} />

                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={5}></Grid>
                            <Grid item xs={2} style={{ textAlign: "center", marginTop: "15px" }}>
                                <Button variant="contained" color="primary" size="small" className={classes.button} onClick={getGeolocalizacion}
                                        disabled={!habilitaBuscarUbicacion}>
                                    <LocationOn />
                                    {/* Buscar Ubicación */
                                        traducirButton(13)}
                                </Button>
                            </Grid>
                            <Grid item xs={5}></Grid>

                        </Grid>
                    </Container>
                </DialogContentText>

                <Container maxWidth="xl" fixed style={{ paddingTop: "5px" }}>
                    {buscandoCoordenadas &&
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <ReactLoading type="spin" color="#19754e" height={40} width={40} />
                        </div>
                    }
                    {!buscandoCoordenadas &&
                        < Map
                            center={{ lat: ubicacionVerificada.latitud !== 0 ? ubicacionVerificada.latitud : ubicacionOriginal.latitud, lng: ubicacionVerificada.longitud !== 0 ? ubicacionVerificada.longitud : ubicacionOriginal.longitud }}
                            height='500px'
                            zoom={zoom}
                            setUbicacionVerificada={setUbicacionMapa}
                            onZoomChanged={handleZoomChanged}
                        />
                    }

                    {
                        showAlert &&
                        <Modal
                            open={showAlert}
                            onClose={handleCloseModal}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            {alertText}
                        </Modal>
                    }

                    {
                        showAlertError &&
                        <Modal
                            open={showAlertError}
                            onClose={handleCloseModal}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            {alertTextError}
                        </Modal>
                    }

                    {showAlertGeopunto &&
                        <ConfirmDireccion label={traducirMessage(24) /* ¿Desea continuar con la dirección verificada? */} abierto={showAlertGeopunto} cerrar={cerrarCancelarDireccion} verificar={cerrarConfirmarDireccion} noverificar={cerrarGuardarDireccion} />
                    }
                </Container>
            </DialogContent>

            <DialogActions>
                <Button variant="contained" className={classes.button} onClick={validarDireccion} color="primary" disabled={!habilitaGuardar}>
                    {/* Guardar Dirección */
                        traducirButton(14)}
                </Button>
            </DialogActions>
        </Dialog>
        {
            showLoading &&
            <>
                <LoadingDialog titulo={traducirLabel(240)/* Procesando */} abierto={true} />
            </>
        }

        {mostrarConfirm &&
        //"Cerrar"
            <ConfirmDialog titulo={traducirLabel(32)} contenido={traducirMessage(28)/* ¿Desea salir sin guardar los cambios? */}
                abierto={mostrarConfirm} confirmar={cerrar}
                cerrar={() => setMostrarConfirm(false)} />
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    ayuda: state.ayuda
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(AgregarDireccion);

